module.exports = "/images/cover-12.jpg";